var map = {
	"./CHENLI_logo.png": "53e8",
	"./Chart_fill.png": "230d",
	"./ChineseToEnglish.png": "aac6",
	"./Google Logo.png": "13c5",
	"./Img_load_box_fill.png": "2869",
	"./Menu_close.png": "0edb",
	"./Menu_open.png": "77d2",
	"./NOrecordID.png": "5d7f",
	"./ai/AI_A.png": "8f38",
	"./ai/AI_A_active.png": "f9a4",
	"./ai/AI_LOGO.png": "2686",
	"./ai/AI_LOGO2.png": "3709",
	"./ai/AI_LOGO_en.png": "3a7b",
	"./ai/Arrow1.png": "2d21",
	"./ai/Arrow2.png": "ae29",
	"./ai/Arrow3.png": "ff70",
	"./ai/Arrow4.png": "373b",
	"./ai/Setting_line_duotone.png": "bfcd",
	"./ai/Subtract.png": "19e4",
	"./ai/arrow_R.png": "2698",
	"./ai/bg_login_L.png": "b553",
	"./ai/btn_A1.png": "0c21",
	"./ai/btn_A1_active.png": "d77b",
	"./ai/btn_A2.png": "b35b",
	"./ai/btn_A2_active.png": "d7a4",
	"./ai/btn_A3.png": "05da",
	"./ai/btn_A3_active.png": "042a",
	"./ai/btn_A4.png": "defa",
	"./ai/btn_A4_active.png": "d304",
	"./ai/btn_A5.png": "1d36",
	"./ai/btn_A5_active.png": "1dae",
	"./ai/btn_AItalk_CN.png": "bd26",
	"./ai/btn_AItalk_CN_active_blue.png": "6bc0",
	"./ai/btn_AItalk_CN_active_perple.png": "8328",
	"./ai/btn_AItalk_CN_active_perple_jp.png": "7683",
	"./ai/btn_AItalk_CN_blue.png": "6ee2",
	"./ai/btn_AItalk_CN_perple.png": "29d4",
	"./ai/btn_AItalk_CN_perple_jp.png": "81fb",
	"./ai/btn_AItalk_Re.png": "d8d2",
	"./ai/btn_AItalk_correct.png": "5993",
	"./ai/btn_AItalk_correct_active.png": "3590",
	"./ai/btn_AItalk_darkblue.png": "967c",
	"./ai/btn_AItalk_lightBlue.png": "c449",
	"./ai/btn_AItalk_lightBlue_active.png": "f57c",
	"./ai/btn_AItalk_play.png": "8702",
	"./ai/btn_AItalk_play_dark.png": "8a55",
	"./ai/btn_AItalk_play_loading_circle.png": "4d79",
	"./ai/btn_AItalk_play_nodata.png": "b61a",
	"./ai/btn_AItalk_play_perple.png": "918c",
	"./ai/btn_AItalk_resemblance.png": "1527",
	"./ai/btn_AItalk_resemblance_active.png": "7967",
	"./ai/btn_AItalk_voice.png": "5ba5",
	"./ai/btn_AItalk_voice_active.png": "e592",
	"./ai/btn_M.png": "2e72",
	"./ai/btn_P.png": "5408",
	"./ai/btn_Play.png": "bfae",
	"./ai/btn_Tips.png": "c031",
	"./ai/btn_Tips_active.png": "4256",
	"./ai/btn_V.png": "7167",
	"./ai/btn_continue.png": "5d7e",
	"./ai/btn_del.png": "7d68",
	"./ai/btn_score.png": "6644",
	"./ai/btn_translate_btn.png": "d685",
	"./ai/btn_translate_btn_jp.png": "65f4",
	"./ai/check_btn.png": "e168",
	"./ai/closeBtn.png": "f155",
	"./ai/coolicon.png": "4932",
	"./ai/coolicon_white.png": "13ba",
	"./ai/copy.png": "ce18",
	"./ai/del_btn.png": "1976",
	"./ai/file_save.png": "f953",
	"./ai/ham.png": "4842",
	"./ai/icon_re.png": "3ee4",
	"./ai/icon_speed.png": "5ce0",
	"./ai/icon_speed_off.png": "67ff",
	"./ai/icon_text.png": "aed2",
	"./ai/icon_text_off.png": "7de5",
	"./ai/icon_voice_bg.png": "c091",
	"./ai/icon_voice_female_off.png": "9aff",
	"./ai/icon_voice_female_on.png": "dfb0",
	"./ai/icon_voice_male_off.png": "f244",
	"./ai/icon_voice_male_on.png": "5a78",
	"./ai/img_popup_success.png": "8270",
	"./ai/loading_circle.png": "ebe5",
	"./ai/login_L.png": "3ecc",
	"./ai/login_head.png": "5927",
	"./ai/login_robot.png": "4187",
	"./ai/logo.png": "302e",
	"./ai/logo_m.png": "981b",
	"./ai/mic_C.png": "396e",
	"./ai/mic_C_onreconation.png": "fa2e",
	"./ai/mic_C_onrecord.png": "4753",
	"./ai/mic_active.png": "9443",
	"./ai/mic_loading.png": "dd83",
	"./ai/microphone.png": "19c4",
	"./ai/myVoice.png": "3dd3",
	"./ai/notOpenKeyboard.png": "bea2",
	"./ai/openKeyboard.png": "fe62",
	"./ai/play_icon.png": "4415",
	"./ai/player_icon.png": "4a5f",
	"./ai/plusB.png": "a830",
	"./ai/plusS.png": "80d7",
	"./ai/plusSS.png": "022d",
	"./ai/popup_error.png": "4c74",
	"./ai/quote.png": "4ac2",
	"./ai/re_icon.png": "a977",
	"./ai/recording_img2.png": "78f7",
	"./ai/robat_icon.png": "f1df",
	"./ai/robotL.png": "fd21",
	"./ai/robotR.png": "6208",
	"./ai/robot_notice.png": "b1ac",
	"./ai/submit_icon.png": "0f39",
	"./ai/support.png": "b773",
	"./ai/test_btn.png": "de22",
	"./ai/tips_btn.png": "e398",
	"./ai/translate_btn_off.png": "0922",
	"./ai/translate_btn_on.png": "5156",
	"./ai_check.png": "2819",
	"./banner.png": "5b08",
	"./bannerM.png": "20e0",
	"./bg01.png": "073f",
	"./bg02.png": "6d34",
	"./bg03.png": "0cfd",
	"./bg04.png": "3fde",
	"./bg_login_LL.png": "a2a6",
	"./bg_login_ML.png": "075e",
	"./btn_download_report.png": "4a55",
	"./btn_start.png": "b625",
	"./chat_text.png": "2ef1",
	"./check_btn.png": "d417",
	"./cover.png": "d538",
	"./essay_text.png": "5ff3",
	"./exchange.png": "9768",
	"./finish_btn.png": "702c",
	"./gept/259.png": "6766",
	"./gept/Expand_down.png": "1c88",
	"./gept/Group 8701.png": "bd22",
	"./gept/Polygon.png": "82a1",
	"./gept/arrow_down.png": "79bf",
	"./gept/backRouter.png": "2d34",
	"./gept/border_active.png": "e341",
	"./gept/border_finish.png": "0176",
	"./gept/border_notStart.png": "d0a7",
	"./gept/check_circle0.png": "4770",
	"./gept/check_circle1.png": "be99",
	"./gept/clode_btn2.png": "98fa",
	"./gept/closeTips.png": "5b44",
	"./gept/describe_image.png": "cfd2",
	"./gept/error_icon.png": "71a6",
	"./gept/icon_check.png": "db22",
	"./gept/icon_close.png": "3071",
	"./gept/icon_light.png": "45df",
	"./gept/list_logo.png": "d3ca",
	"./gept/list_logo2.png": "127a",
	"./gept/logo_header.png": "03a9",
	"./gept/m_play.png": "8987",
	"./gept/m_play_gray.png": "b3c0",
	"./gept/micro01_finish.png": "996c",
	"./gept/micro01_off.png": "e65b",
	"./gept/open_link.png": "27d7",
	"./gept/p01.png": "86d8",
	"./gept/p02.png": "f728",
	"./gept/play_test.png": "f94c",
	"./gept/play_test_on.png": "a7d0",
	"./gept/question_order_check.png": "6b3d",
	"./gept/question_order_line.png": "a329",
	"./gept/question_order_lineM.png": "0929",
	"./gept/read_loading.png": "e190",
	"./gept/recording_img.png": "e8ca",
	"./gept/recording_img2.png": "ea82",
	"./gept/recording_img3.png": "2929",
	"./gept/robot01_finish.png": "ac51",
	"./gept/robot01_off.png": "fece",
	"./gept/robot01_on.png": "0df7",
	"./gept/star.png": "5ee5",
	"./gept/startRecord_btn_read.png": "214b",
	"./gept/stock-vector.png": "695e",
	"./gept/stop_btn_read.png": "3ebb",
	"./gept/tips.png": "56fb",
	"./gept/tips2.png": "e829",
	"./gept/tips3.png": "591e",
	"./gept/true_icon.png": "50da",
	"./gept/voice_play.png": "24c5",
	"./gept/voice_play2.png": "4b32",
	"./gept/voice_stop.png": "abec",
	"./goPractice.png": "2324",
	"./goRecord.png": "b915",
	"./head_news.png": "7e49",
	"./loading_img.png": "0cab",
	"./login_R.png": "b4b2",
	"./login_logo.png": "01c3",
	"./logo.png": "a1d8",
	"./logo_text.png": "4e28",
	"./preview_img.png": "aaa6",
	"./recordID.png": "bd18",
	"./record_false.png": "27c7",
	"./record_true.png": "363c",
	"./reference_article.png": "0f16",
	"./reference_article_m.png": "9c73",
	"./register.png": "70b7",
	"./robot_notice.png": "fb04",
	"./scan_btn.png": "505d",
	"./start_btn.png": "6d2a",
	"./success_icon.png": "e8da",
	"./typeSpeaking.png": "69de",
	"./typeWriting.png": "a839"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3c";